<template>
  <div>
    <div class="bottom-nav">
      <router-link to="/about" class="bottom-nav-item">
        <img
          ref="aboutBottomNav"
          class="bottom-nav-item-left "
          src="../assets/about.png"
          alt="">
        <div class="bottom-nav-item-right">
          <div class="bottom-nav-item-right-title">关于</div>
          <div class="bottom-nav-item-right-desc">公司发展历程，媒体报道内容</div>
        </div>
      </router-link>
      <a href="https://www.zhipin.com/gongsir/b4a008a6a499944603J92ty9Fw~~.html?ka=all-jobs-top"
         class="bottom-nav-item" target="_blank">

        <img class="bottom-nav-item-left " src="../assets/talents.png" alt="">

        <div class="bottom-nav-item-right">
          <div class="bottom-nav-item-right-title">人才招聘</div>
          <div class="bottom-nav-item-right-desc">大量引进优秀人才，欢迎投递简历</div>
        </div>
      </a>
      <router-link to="/cooperation" class="bottom-nav-item">

        <img class="bottom-nav-item-left " src="../assets/message.png"
             alt="">

        <div class="bottom-nav-item-right">
          <div class="bottom-nav-item-right-title">联系我们</div>
          <div class="bottom-nav-item-right-desc">邮件：BD@yongwangkeji.cn</div>
        </div>
      </router-link>
    </div>
    <div class="web-footer">
      <div class="web-bottom " :style="'margin-left:'+ marginLeft+'px'">
        <ul>
          <li>
            <router-link to="/about">关于勇往</router-link>
            <span class="web-bottom-li-split">|</span>
          </li>
          <li>
            <router-link to="/about/cooperation">联系我们</router-link>
            <span class="web-bottom-li-split">|</span>
          </li>
          <li>
            <router-link to="/privacy">隐私政策</router-link>
            <span class="web-bottom-li-split">|</span>
          </li>
          <li>
            <router-link to="/terms">使用条款</router-link>
            <span class="web-bottom-li-split">|</span>
          </li>
          <li>
            <a href="https://mp.weixin.qq.com/s/tGE09itsJ0v4vOc7FtZH2A" target="_blank">防诈骗提醒</a>
          </li>

        </ul>
        <div class="copy" style="margin-top: 0.26rem">
          <div><a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备{{recordNum}}号</a> | 广州勇往科技有限公司.All rights
            reserved.
          </div>
          <!--<div>联系微信：tappop</div>-->
          <div>服务信箱：BD@yongwangkeji.cn</div>
          <div style="margin-top: 0.1rem;font-size: 0.2rem">
            游戏健康忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "yw_footer",
    data() {
      return {
        marginLeft: 0,
        localUrl: window.location.href,
        recordNum: 17025202, //备案号
      }
    },
    mounted() {
      this.resetMarginLeft();
      const that = this;
      window.addEventListener("resize", function () {
        return (() => {
          if (!that.timer) {
            that.timer = true
            setTimeout(function () {
              that.resetMarginLeft();
              that.timer = false
            }, 500)
          }
        })()
      });
    },
    created() {

    },
    methods: {
      resetMarginLeft() {
        this.marginLeft = this.$refs.aboutBottomNav.getBoundingClientRect().left;
      }
    }
  }
</script>

<style scoped>
  .bottom-nav {
    padding: 0 10px;
  }

  .bottom-nav-item {
    display: flex;
    color: #fff;
    margin-right: 3rem;
  }

  .bottom-nav-item:last-child {
    margin-right: 0;
  }

  .bottom-nav-item-right {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    /*height: 1.64rem;*/
  }

  .bottom-nav-item-right-title {
    font-size: 0.48rem;

  }

  .bottom-nav-item-right-desc {
    font-size: 0.25rem;
  }

  .bottom-nav-item-left {
    background-color: #0E99C4;
    height: 1.64rem;
    width: 1.64rem;
    border-radius: 1.64rem;
    margin-right: 0.4rem;
  }

  .bottom-nav {
    height: 3.7rem;
    width: 100vw;
    background: #0E99C4;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    .bottom-nav-item {
      display: flex;
      color: #fff;
      margin-right: 0.5rem;
    }
  }

  .web-footer, .web-bottom {
    width: 100vw;
  }

  @media screen and (max-width: 490px) {
    .bottom-nav {
      padding: 0 4px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/yw_footer.vue